var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_167)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_59_167",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6738 24H38.3095V60.39L33.3595 59.4569V54.5583L27.4667 53.6252V64.5888L44.6738 69.0209V24ZM49.448 24H67.0667L65.8881 30.9747H56.1738V42.4203H65.8881L64.7095 65.5219L49.448 69.0209V61.7896L59.7595 58.2906L60.3549 48.7265L49.448 50.2894V24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7C4 4.23858 6.23858 2 9 2H87C89.7614 2 92 4.23858 92 7V85C92 87.7614 89.7614 90 87 90H9C6.23858 90 4 87.7614 4 85V7Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.6738 24H38.3095V60.39L33.3595 59.4569V54.5583L27.4667 53.6252V64.5888L44.6738 69.0209V24ZM49.448 24H67.0667L65.8881 30.9747H56.1738V42.4203H65.8881L64.7095 65.5219L49.448 69.0209V61.7896L59.7595 58.2906L60.3549 48.7265L49.448 50.2894V24Z",
    fill: "#B8B8B8",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6738 24H38.3095V60.39L33.3595 59.4569V54.5583L27.4667 53.6252V64.5888L44.6738 69.0209V24ZM49.448 24H67.0667L65.8881 30.9747H56.1738V42.4203H65.8881L64.7095 65.5219L49.448 69.0209V61.7896L59.7595 58.2906L60.3549 48.7265L49.448 50.2894V24Z",
    fill: "#B8B8B8",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6738 24H38.3095V60.39L33.3595 59.4569V54.5583L27.4667 53.6252V64.5888L44.6738 69.0209V24ZM49.448 24H67.0667L65.8881 30.9747H56.1738V42.4203H65.8881L64.7095 65.5219L49.448 69.0209V61.7896L59.7595 58.2906L60.3549 48.7265L49.448 50.2894V24Z",
    fill: "#E0E0E0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6738 24H38.3095V60.39L33.3595 59.4569V54.5583L27.4667 53.6252V64.5888L44.6738 69.0209V24ZM49.448 24H67.0667L65.8881 30.9747H56.1738V42.4203H65.8881L64.7095 65.5219L49.448 69.0209V61.7896L59.7595 58.2906L60.3549 48.7265L49.448 50.2894V24Z",
    fill: "#E0E0E0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6738 24H45.6738V23H44.6738V24ZM38.3095 24V23H37.3095V24H38.3095ZM38.3095 60.39L38.1243 61.3727L39.3095 61.5961V60.39H38.3095ZM33.3595 59.4569H32.3595V60.286L33.1743 60.4396L33.3595 59.4569ZM33.3595 54.5583H34.3595V53.7041L33.5159 53.5706L33.3595 54.5583ZM27.4667 53.6252L27.6231 52.6375L26.4667 52.4544V53.6252H27.4667ZM27.4667 64.5888H26.4667V65.3639L27.2172 65.5572L27.4667 64.5888ZM44.6738 69.0209L44.4244 69.9893L45.6738 70.3111V69.0209H44.6738ZM49.448 24V23H48.448V24H49.448ZM67.0667 24L68.0527 24.1666L68.2498 23H67.0667V24ZM65.8881 30.9747V31.9747H66.7333L66.8741 31.1414L65.8881 30.9747ZM56.1738 30.9747V29.9747H55.1738V30.9747H56.1738ZM56.1738 42.4203H55.1738V43.4203H56.1738V42.4203ZM65.8881 42.4203L66.8868 42.4713L66.9404 41.4203H65.8881V42.4203ZM64.7095 65.5219L64.933 66.4966L65.6697 66.3277L65.7082 65.5729L64.7095 65.5219ZM49.448 69.0209H48.448V70.2762L49.6714 69.9956L49.448 69.0209ZM49.448 61.7896L49.1266 60.8426L48.448 61.0729V61.7896H49.448ZM59.7595 58.2906L60.0809 59.2375L60.7159 59.022L60.7576 58.3527L59.7595 58.2906ZM60.3549 48.7265L61.353 48.7887L61.4294 47.5624L60.2131 47.7366L60.3549 48.7265ZM49.448 50.2894H48.448V51.4429L49.5898 51.2793L49.448 50.2894ZM44.6738 23H38.3095V25H44.6738V23ZM37.3095 24V60.39H39.3095V24H37.3095ZM38.4948 59.4073L33.5448 58.4742L33.1743 60.4396L38.1243 61.3727L38.4948 59.4073ZM34.3595 59.4569V54.5583H32.3595V59.4569H34.3595ZM33.5159 53.5706L27.6231 52.6375L27.3103 54.6129L33.2031 55.5459L33.5159 53.5706ZM26.4667 53.6252V64.5888H28.4667V53.6252H26.4667ZM27.2172 65.5572L44.4244 69.9893L44.9232 68.0525L27.7161 63.6204L27.2172 65.5572ZM45.6738 69.0209V24H43.6738V69.0209H45.6738ZM49.448 25H67.0667V23H49.448V25ZM66.0806 23.8334L64.9021 30.8081L66.8741 31.1414L68.0527 24.1666L66.0806 23.8334ZM65.8881 29.9747H56.1738V31.9747H65.8881V29.9747ZM55.1738 30.9747V42.4203H57.1738V30.9747H55.1738ZM56.1738 43.4203H65.8881V41.4203H56.1738V43.4203ZM64.8894 42.3694L63.7108 65.4709L65.7082 65.5729L66.8868 42.4713L64.8894 42.3694ZM64.486 64.5472L49.2245 68.0462L49.6714 69.9956L64.933 66.4966L64.486 64.5472ZM50.448 69.0209V61.7896H48.448V69.0209H50.448ZM49.7693 62.7366L60.0809 59.2375L59.4382 57.3436L49.1266 60.8426L49.7693 62.7366ZM60.7576 58.3527L61.353 48.7887L59.3569 48.6644L58.7615 58.2284L60.7576 58.3527ZM60.2131 47.7366L49.3061 49.2995L49.5898 51.2793L60.4968 49.7164L60.2131 47.7366ZM50.448 50.2894V24H48.448V50.2894H50.448ZM9 3H87V1H9V3ZM91 7V85H93V7H91ZM87 89H9V91H87V89ZM5 85V7H3V85H5ZM9 89C6.79086 89 5 87.2091 5 85H3C3 88.3137 5.68629 91 9 91V89ZM91 85C91 87.2091 89.2091 89 87 89V91C90.3137 91 93 88.3137 93 85H91ZM87 3C89.2091 3 91 4.79086 91 7H93C93 3.68629 90.3137 1 87 1V3ZM9 1C5.68629 1 3 3.68629 3 7H5C5 4.79086 6.79086 3 9 3V1Z",
    fill: "url(#paint0_linear_59_167)",
    mask: "url(#path-1-inside-1_59_167)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_167",
    x: 0,
    y: 0,
    width: 96,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_167"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_167",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_167",
    x1: 48,
    y1: 2,
    x2: 48,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.053e2763fc314adc82e913c30df59607.svg";
export { ForwardRef as ReactComponent };